import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const ClockDollarIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <path
      d="M34.5867 25.9373C34.1786 26.8781 33.6848 27.7793 33.1115 28.6296C33.1589 28.7584 33.1864 28.8937 33.193 29.0307C33.192 29.8001 32.5686 30.4235 31.7993 30.4245H31.6854C30.5112 31.7342 29.1388 32.8515 27.6182 33.7357V34.6057C27.6182 35.3755 28.2421 35.9995 29.0119 35.9995C29.7816 35.9995 30.4056 35.3755 30.4056 34.6057V33.212H31.7993C33.5304 33.2184 35.085 32.1535 35.7044 30.537C36.3238 28.9205 35.8788 27.0893 34.5867 25.9373Z"
      fill="#F0CBA7"
    />
    <path
      d="M31.7993 27.637H30.4056V30.4245H31.6854C32.2012 29.8594 32.6777 29.2597 33.1117 28.6296C32.9412 28.0454 32.4079 27.642 31.7993 27.637Z"
      fill="#F0CBA7"
    />
    <path
      d="M24.8307 23.4558C24.8317 24.2251 25.4551 24.8485 26.2245 24.8495H27.6182V22.0621H26.2245C25.4551 22.0631 24.8317 22.6865 24.8307 23.4558Z"
      fill="#F0CBA7"
    />
    <path
      d="M24.8307 33.212C24.061 33.212 23.437 32.588 23.437 31.8182C23.437 31.0485 24.061 30.4245 24.8307 30.4245H27.6181V27.6371H26.2244C23.9152 27.6371 22.0433 25.7651 22.0433 23.4559C22.0433 21.1467 23.9152 19.2747 26.2244 19.2747H27.6181V17.881C27.6181 17.1112 28.2421 16.4873 29.0118 16.4873C29.7815 16.4873 30.4055 17.1112 30.4055 17.881V19.2747H33.193C33.9627 19.2747 34.5867 19.8987 34.5867 20.6684C34.5867 21.4382 33.9627 22.0622 33.193 22.0622H30.4055V24.8496H31.7992C32.8313 24.8528 33.8252 25.2407 34.5867 25.9374C37.8994 18.3734 35.2249 9.52347 28.2775 5.06021C21.3301 0.59695 12.1694 1.84351 6.66716 8.00086C1.16496 14.1582 0.95242 23.401 6.16577 29.8048C11.3791 36.2086 20.4729 37.8749 27.6181 33.7357V33.212H24.8307ZM20.6495 19.2747C20.6495 20.0444 20.0256 20.6684 19.2558 20.6684H12.2873C11.5176 20.6684 10.8936 20.0444 10.8936 19.2747C10.8936 18.505 11.5176 17.881 12.2873 17.881H17.8621V9.51863C17.8621 8.74889 18.4861 8.1249 19.2558 8.1249C20.0256 8.1249 20.6495 8.74889 20.6495 9.51863V19.2747Z"
      fill="#F0CBA7"
    />
    <path
      d="M16.3308 31.6621C7.86385 31.6621 1 24.7981 1 16.331C1 7.86396 7.86385 1.00002 16.3308 1.00002C23.3251 0.977593 29.528 5.48883 31.6617 12.1499"
      stroke="#EA7200"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.3308 16.331V6.57495" stroke="#EA7200" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.3309 16.331H9.3623" stroke="#EA7200" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M21.9057 28.8745H28.8742C30.4137 28.8745 31.6617 27.6265 31.6617 26.0871C31.6617 24.5476 30.4137 23.2996 28.8742 23.2996H23.2994C21.7599 23.2996 20.512 22.0516 20.512 20.5121C20.512 18.9727 21.7599 17.7247 23.2994 17.7247H30.2679"
      stroke="#226937"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M26.0868 14.9373V31.662" stroke="#226937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
));
